import * as React from "react";
const SvgFiRrHouseFlood = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-house-flood_svg__a)">
      <path d="M5.07 20.633c-.006.013 0-.013 0 0" />
      <path d="M22.332 21.49a2.2 2.2 0 0 1-3.387-.817 1.005 1.005 0 0 0-1.89 0 2.278 2.278 0 0 1-4.11 0 1.005 1.005 0 0 0-1.89 0 2.274 2.274 0 0 1-4.126-.041 1.012 1.012 0 0 0-1.859 0A2.2 2.2 0 0 1 3.582 21.9a2.2 2.2 0 0 1-1.912-.412 1.002 1.002 0 0 0-1.338 1.49A4.186 4.186 0 0 0 6 22.775a4.336 4.336 0 0 0 6 0 4.336 4.336 0 0 0 6 0 4.185 4.185 0 0 0 5.668.2 1 1 0 0 0-1.336-1.485M2 17v-5.831a1 1 0 0 1 .293-.707l7.585-7.583a3.01 3.01 0 0 1 4.244 0l7.585 7.586c.185.186.29.437.293.7V17a1 1 0 0 0 2 0v-5.831a2.98 2.98 0 0 0-.879-2.121l-7.585-7.586a5.01 5.01 0 0 0-7.072 0L.879 9.048A2.98 2.98 0 0 0 0 11.168V17a1 1 0 1 0 2 0" />
      <path d="M12 13.03a5 5 0 0 0-4.82 3.681A1.01 1.01 0 0 0 8.14 18a1.034 1.034 0 0 0 .978-.79 3 3 0 0 1 5.766 0 1.034 1.034 0 0 0 .977.79 1.01 1.01 0 0 0 .96-1.288 5 5 0 0 0-4.82-3.68" />
    </g>
    <defs>
      <clipPath id="fi-rr-house-flood_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseFlood;
